/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useState, useEffect } from 'react';
import { initI18n } from '../i18nClient';
import { I18nProvider, I18nProviderProps } from '../i18nProvider';
import { MxContextLanguageDetector } from '@soluto-private/mx-i18n';
import { LanguageDetectorModule } from 'i18next';
import { I18N_CONFIG } from '../../config';
// eslint-disable-next-line import/no-unresolved
import { Key, listen, storageEvents } from '@soluto-private/mx-context';

type ExtractPromiseType<T> = T extends Promise<infer U> ? U : never;

export type ContentfulConfiguredI18nProps = Omit<I18nProviderProps, 'value'>;

export const ContentfulConfiguredI18n: React.FC<ContentfulConfiguredI18nProps> = ({
  ...props
}) => {
  const [i18n, setI18n] = useState<
    ExtractPromiseType<ReturnType<typeof initI18n>> | undefined
  >();

  useEffect(() => {
    const init = async () => {
      try {
        const i18nInit = await initI18n({
          ...I18N_CONFIG,
          plugins: [
            (MxContextLanguageDetector as unknown) as LanguageDetectorModule,
          ],
        });
        setI18n(i18nInit);
      } catch (error) {
        if (error) {
          const i18nError = new Error(JSON.stringify(error));
          console.error(
            'i18n initialization failed',
            new Error(i18nError.message)
          );
        }
      }
    };

    listen(storageEvents.keyUpdated(Key.Language), init);

    void init();
  }, []);

  return <I18nProvider value={i18n} {...props} />;
};
